var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDisplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 81,
    viewBox: "0 0 82 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 40.5,
    r: 40.5,
    fill: "#E0F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4832 58.6693H33.4999C30.6332 58.6693 28.4832 57.9026 27.1499 56.3859C25.8166 54.8693 25.2999 52.6693 25.6499 49.8193L27.1499 37.3193C27.5832 33.6359 28.5166 30.3359 35.0166 30.3359H47.0166C53.4999 30.3359 54.4332 33.6359 54.8832 37.3193L56.3832 49.8193C56.7165 52.6693 56.2166 54.8859 54.8832 56.3859C53.4999 57.9026 51.3666 58.6693 48.4832 58.6693ZM34.9999 32.8359C30.1999 32.8359 29.9666 34.7359 29.6166 37.6026L28.1166 50.1026C27.8666 52.2192 28.1666 53.7693 29.0166 54.7193C29.8666 55.6693 31.3666 56.1526 33.4999 56.1526H48.4832C50.6166 56.1526 52.1165 55.6693 52.9665 54.7193C53.8165 53.7693 54.1166 52.2192 53.8666 50.1026L52.3666 37.6026C52.0166 34.7192 51.7999 32.8359 46.9832 32.8359H34.9999Z",
    fill: "#00A4D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6667 35.3359C46.9833 35.3359 46.4167 34.7693 46.4167 34.0859V28.2526C46.4167 26.4526 45.3 25.3359 43.5 25.3359H38.5C36.7 25.3359 35.5833 26.4526 35.5833 28.2526V34.0859C35.5833 34.7693 35.0167 35.3359 34.3333 35.3359C33.65 35.3359 33.0833 34.7693 33.0833 34.0859V28.2526C33.0833 25.0693 35.3167 22.8359 38.5 22.8359H43.5C46.6833 22.8359 48.9167 25.0693 48.9167 28.2526V34.0859C48.9167 34.7693 48.35 35.3359 47.6667 35.3359Z",
    fill: "#00A4D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0167 50.3828H34.3333C33.65 50.3828 33.0833 49.8161 33.0833 49.1328C33.0833 48.4495 33.65 47.8828 34.3333 47.8828H55.0167C55.7 47.8828 56.2667 48.4495 56.2667 49.1328C56.2667 49.8161 55.7 50.3828 55.0167 50.3828Z",
    fill: "#00A4D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDisplay);
export default __webpack_public_path__ + "static/media/add_display.b527feb1a82abda9ebcfdbbca59eecfa.svg";
export { ForwardRef as ReactComponent };